import { render, staticRenderFns } from "./kpzl.vue?vue&type=template&id=507a40f3&scoped=true"
import script from "./kpzl.vue?vue&type=script&lang=js"
export * from "./kpzl.vue?vue&type=script&lang=js"
import style0 from "./kpzl.vue?vue&type=style&index=0&id=507a40f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507a40f3",
  null
  
)

export default component.exports